<template>
  <v-container grid-list-xl fluid fill-height>
    <v-layout wrap align-center justify-center>
      <v-card class="mx-auto" width="100%" max-width="500" outlined>
        <v-card-title>Hemos actualizado la aplicación</v-card-title>
        <v-card-text>
          <p>
            Por favor, haz click en "actualizar" para disfrutar de las nuevas funciones que eato tiene para ofrecerte.
            Leer más sobre los nuevos cambios <a href="https://eato.slab.com/posts/eato-latest-release-j7cympvn" target="_blank">haz click aquí</a>.
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            depressed
            rounded
            color="primary"
            @click="refreshApp">
            Actualizar ahora
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  computed: {
    version () {
      return process.env.VUE_APP_VERSION
    }
  },
  methods: {
    async refreshApp () {
      await this.$store.dispatch('login/refreshLogin')

      this.$store.commit('setVersion', this.version)

      if (this.$store.state.userProvider) {
        this.$router.push({ name: 'SelectProvider' })
      } else {
        this.$router.push({ name: 'SelectRestaurant' })
      }
    }
  }
}
</script>
